package com.corbettcode.allaboutrocks.pages

import androidx.compose.runtime.Composable
import com.corbettcode.allaboutrocks.HeadlineTextStyle
import com.corbettcode.allaboutrocks.HeroContainerStyle
import com.corbettcode.allaboutrocks.PageHeadlineStyle
import com.corbettcode.allaboutrocks.PageSectionTitleStyle
import com.corbettcode.allaboutrocks.SectionTextStyle
import com.corbettcode.allaboutrocks.components.layouts.PageLayoutData
import com.corbettcode.allaboutrocks.components.widgets.CarouselOfSections
import com.corbettcode.allaboutrocks.toSitePalette
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment.CenterHorizontally
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import kotlin.time.Duration.Companion.seconds

// --- Constants ---
private val HERO_IMAGE_MAX_WIDTH = 400.px

private val PRESS_IMAGE_MAX_HEIGHT = 800.px
private val PRESS_IMAGE_MAX_WIDTH = 900.px
private val PRESS_IMAGE_SMALLER_MAX_WIDTH = 600.px
private val PRESS_IMAGE_VERTICAL_MARGIN = 24.px

private val PROGRAM_POSTER_IMAGE_MAX_HEIGHT = 800.px
private val PROGRAM_POSTER_IMAGE_MAX_WIDTH = 400.px
private val PROGRAM_POSTER_IMAGE_VERTICAL_MARGIN = 24.px

@InitRoute
fun initLearnTumbleRocks(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Lean How to Tumble Rocks"))
}

//
//
//

@Composable
private fun LearnTumbleRocksBookSection() {
    val sitePalette = ColorMode.current.toSitePalette()
    val textColor = if (ColorMode.current == ColorMode.LIGHT) Colors.Black else Colors.White

    Div(SectionTextStyle.toAttrs()) {
        Column {
            SpanText(
                "Rock Tumbling Books"
                , PageSectionTitleStyle.toModifier()
                    .color(textColor)
                    .align(alignment = CenterHorizontally)
                    .margin(topBottom = 2.cssRem)
            )
        }

        CarouselOfSections(
            items = learnTumbleRocksCarouselSlides
            , frameDuration = 8.seconds
        )
    }
}

@Composable
private fun LearnTumbleRocksHeadline() {
    val sitePalette = ColorMode.current.toSitePalette()
    val textColor = if (ColorMode.current == ColorMode.LIGHT) Colors.Black else Colors.White

    Div(HeadlineTextStyle.toAttrs()) {
        Column {
            SpanText(
                "Learn How to Tumble Rocks"
                , PageHeadlineStyle.toModifier()
                    .color(textColor)
                    .align(alignment = CenterHorizontally)
            )
        }
    }
}

@Composable
private fun LearnTumbleRocksHero() {
    LearnTumbleRocksHeadline()

    // 1 column on mobile, 2 columns on md+ (text left, image right)
    SimpleGrid(
        numColumns = numColumns(1, md = 2),
        modifier = HeroContainerStyle.toModifier().fillMaxWidth().gap(2.cssRem)
    ) {
//        Box {
//            Column(Modifier.gap(2.cssRem)) {
//
//                Image(
//                    src = "/images/learn/tumble_rocks/rock-tumbling-book.jpg",
//                    alt = "how to tumble rocks",
//                    modifier = Modifier
//                        .maxWidth(HERO_IMAGE_MAX_WIDTH)
//                        .fillMaxWidth()  // shrinks naturally on small screens
//                )
//            }
//        }
//
//        Image(
//            src = "/images/learn/identify_rocks/easy_jasper_identification.jpg",
//            alt = "Easy jasper identification",
//            modifier = Modifier
//                .maxWidth(HERO_IMAGE_MAX_WIDTH)
//                .fillMaxWidth()  // shrinks naturally on small screens
//        )
    }
}

@Composable
private fun LearnTumbleRocksGritSection() {
    // Single centered column — image scales with viewport on small screens
    SimpleGrid(
        numColumns = numColumns(1)
        , modifier = Modifier.fillMaxWidth()
    ) {
//        Image(
//            src = "/images/learn/tumble_rocks/rock-tumbling-book.jpg",
//            alt = "Rock Tumbling book",
//            modifier = Modifier
//                .maxWidth(400.px)
//                .maxHeight(900.px)
//                .fillMaxWidth()  // shrinks on small screens, caps at max on large
//                .margin(top = PRESS_IMAGE_VERTICAL_MARGIN, bottom = PRESS_IMAGE_VERTICAL_MARGIN)
//        )

    }
}

@Page("learn_tumble_rocks")
@Layout(".components.layouts.PageLayout")
@Composable
fun LearnTumbleRocksPage() {
    LearnTumbleRocksHero()
    HorizontalDivider(Modifier
        .fillMaxWidth()
        .margin(topBottom = 2.cssRem)
    )
    LearnTumbleRocksBookSection()
    HorizontalDivider(Modifier
        .fillMaxWidth()
        .margin(topBottom = 4.cssRem)
    )
    LearnTumbleRocksGritSection()
}

val learnTumbleRocksCarouselSlides = listOf<@Composable () -> Unit>(
    {
        SimpleGrid(
            numColumns = numColumns(2)
            , modifier = Modifier.fillMaxWidth()
        ) {
            Image(
                src = "/images/learn/tumble_rocks/rock-tumbling-book.jpg",
                alt = "how to tumble rocks",
                modifier = Modifier
                    .maxWidth(HERO_IMAGE_MAX_WIDTH)
                    .fillMaxWidth()  // shrinks naturally on small screens
            )

            P {
                Text("Modern Rock Tumbling is the only complete and up-to-date guide to tumble polishing rocks and stones.")

            }
        }
    }
    , {
        SimpleGrid(
            numColumns = numColumns(2)
            , modifier = Modifier.fillMaxWidth()
        ) {
            Image(
                src = "/images/learn/tumble_rocks/gemstone-tumbling-cutting-drilling-and-cabochon-making.jpg",
                alt = "how to tumble rocks",
                modifier = Modifier
                    .maxWidth(HERO_IMAGE_MAX_WIDTH)
                    .fillMaxWidth()  // shrinks naturally on small screens
            )

            P {
                Text("This is an excellent book, authored by people who have spent a lifetime making beautiful things from rocks and helping others enjoy the lapidary hobby.")

            }
        }
    }
    , {
        SimpleGrid(
            numColumns = numColumns(2)
            , modifier = Modifier.fillMaxWidth()
        ) {
            Image(
                src = "/images/learn/tumble_rocks/the_complete_guide_book_about_how_to_tumble_polish_rocks.jpg",
                alt = "how to tumble rocks",
                modifier = Modifier
                    .maxWidth(HERO_IMAGE_MAX_WIDTH)
                    .fillMaxWidth()  // shrinks naturally on small screens
            )

            P {
                Text("How to Tumble Polish Rock into Gems is a complete guide book to tumbling and polishing rocks.")

            }
        }
    }
)
